











import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import { Dictionary } from "@/lib/Dictionary.type";

import PlushieUpgradeListItem from "../plushie-upgrade-list-item.interface";

@Component
export default class UpgradesList extends Vue {
  @Prop({ required: true })
  public readonly upgrades!: PlushieUpgradeListItem[];

  public get upgradeTitle(): Dictionary<string> {
    const result: Dictionary<string> = {};

    for (const upgrade of this.upgrades) {
      let title = upgrade.name;

      if (upgrade.quantity && upgrade.quantity > 1) {
        title += ` x${upgrade.quantity}`;
      }

      result[upgrade.id] = title;
    }

    return result;
  }
}
